export const convertCustomerUploadsS3ToCloudFront = (url: string) => {
  const s3BucketUrlPattern =
    /^https?:\/\/sked-customer-uploads\.s3(\.[a-z0-9-]+)?\.amazonaws\.com\/(.+)$/;
  if (s3BucketUrlPattern.test(url)) {
    return url.replace(
      s3BucketUrlPattern,
      "https://customer-uploads.skedsocial.com/$2"
    );
  }
  return url;
};
